module.exports = __webpack_public_path__ + "img/2.d34b586d.png";